module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("Many thanks to Marsha Briscoe, a long-time supporter of my work, and to Judy Lipp, LCSW, for sharing her experience as a mental health professional working with patients who suffer from more than mental illness.")]), _vm._v(" "), _c('p', [_vm._v("My great appreciation goes to Stanley Hilton, native San Franciscan and author, who provided much of the “flavor” of the City by the Bay for this book.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To Eve, Sybil, Truddi, and others who share their bodies with more than one personality.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156ff48b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 66
// module chunks = 0